import React from "react";
import styled from "styled-components";
import PostCodeSearchForm from "components/postcode_search/PostCodeSearchForm";
import meetUs from "illustrations/become-a-carer/resp-meet-us.png";
import { redirectToHomeInsteadFindCare } from "helpers/redirectHelper";

const PostCodeMessage = styled.div`
  text-align: center;
  line-height: 1.2;
`;

const PostCodeMessageHeading = styled.div`
  padding: 10px;
  font-size: 32px;
  color: ${props => props.theme.colors.darkBlue};
`;

const PostCodeMessageSubHeading = styled.div`
  padding: 10px;
  font-size: 22px;
  color: ${props => props.theme.colors.darkBlue};
`;

const PostCodeMessageDynamicHeading = styled(PostCodeMessageSubHeading)`
  display: none;
  @media (min-width: ${({ theme }) => theme.screen.mobile}px) {
    display: block;
  }
`;

const PostCodeMessageButtonDiv = styled.div`
  padding: 10px;
`;

const PostCodeMessageButton = styled.button`
  background-color: ${props => props.theme.colors.red};
  color: ${props => props.theme.colors.white};
  font-family: ${props => props.theme.typography.fontStack};
  font-size: 20px;
  width: 260px;
  min-width: 80px;
  min-height: 58px;
  border: none;
  padding: 0;
  cursor: pointer;
`;

const StyledImage = styled.img`
  width: 200px;
  margin: auto;
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  text-align: center;
`;

const StyledList = styled.ul`
  font-size: 17px;
  list-style-type: none;
  margin: auto;
  padding-left: 0;
  display: block;
  @media (min-width: ${({ theme }) => theme.screen.mobile}px) {
    display: flex;
    justify-content: center;
    flex-wrap: nowrap;
    max-width: 700px;
  }
`;
const StyledListItem = styled.li`
  text-align: center;
  padding: 20px;
  flex: 1;
`;

const StyledListNumber = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 13px;
  background: ${props => props.theme.colors.darkLinen};
  text-align: center;
  line-height: 26px;
  margin: 0 auto 8px;
`;

const StyledListLabel = styled.div`
  margin: auto;
`;

const PostCodeMissingMessage = () => (
  [
    <FlexContainer>
      <div>
        <PostCodeMessageHeading>Ready to get started?</PostCodeMessageHeading>
        <PostCodeMessageDynamicHeading>
          We work with Home Instead, enter your postcode to find your local office
        </PostCodeMessageDynamicHeading>
        <PostCodeSearchForm />
      </div>
    </FlexContainer>,
  ]
);

const PostCodeInvalidMessage = ({ postcode }) => (
  <PostCodeMessage>
    <PostCodeMessageHeading>
      {postcode} is not a valid UK postcode
    </PostCodeMessageHeading>
    <PostCodeMessageSubHeading>
      Please enter a valid postcode and we can match you with Home Instead offices
    </PostCodeMessageSubHeading>
    <PostCodeSearchForm />
  </PostCodeMessage>
);

const PostCodeSuccessMessage = ({ postcode }) => {
  return (
    <PostCodeMessage>
      <PostCodeMessageHeading>
        We work with Home Instead to help families find care!
      </PostCodeMessageHeading>
      <PostCodeMessageSubHeading>
        Click here to read more about Home Instead and get the contact details of your local office, with more than 225 around the UK.
      </PostCodeMessageSubHeading>
      <PostCodeMessageButtonDiv>
        <PostCodeMessageButton onClick={() => redirectToHomeInsteadFindCare(postcode)}>
          Find my local Home Instead
        </PostCodeMessageButton>
      </PostCodeMessageButtonDiv>
      <StyledImage src={meetUs} alt="shaking hands" />
    </PostCodeMessage>
  );
};

const PostCodeSearchMessages = props => {
  const { postcode, postcodeValid } = props;

  if (!postcode) {
    return <PostCodeMissingMessage />;
  }
  if (postcode && !postcodeValid) {
    return <PostCodeInvalidMessage postcode={postcode} />;
  }
  return <PostCodeSuccessMessage postcode={postcode} />;
};

export default PostCodeSearchMessages;
